import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const sharylistGreen = '#379A3D'
const white = '#FFFFFF'
const instanceColor = sharylistGreen
const masterColor = '#01579B'

export default new Vuetify({
  icons: {
    values: {
      checkboxOn: 'mdi-checkbox-marked-outline',
    },
  },
  theme: {
    themes: {
      light: {
        primary: sharylistGreen,
        secondary: colors.grey.darken4,
        accent: colors.green.accent1,
        error: colors.red.darken3,
        info: sharylistGreen,
        success: sharylistGreen,
        warning: colors.orange.darken2,
        anchor: colors.grey.darken4,
        danger: colors.red.darken3,
        background: white,
        instance: instanceColor,
        master: masterColor,
      },
    },
    options: {
      customProperties: true,
    },
  },
})
